import axios from "axios";
export default {
  namespaced: true,
  state: {
    dashboard: null,
    loading: false,
  },
  getters: {
    dashboard(state) {
      return state.dashboard;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_DASHBOARD(state, dashboard) {
      state.dashboard = dashboard;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetch_dashboard({ commit }) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/vp_operations/dashboard");
        commit("SET_DASHBOARD", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
